export const ncdRouteMap = {
  gestion: {
    path: '/ncd/gestion',
    name: 'Gestión de Notas',
  },
  nuevo: {
    path: '/ncd/nuevo',
    name: 'Nuevo',
  },
  modificar: {
    path: `/ncd/modificar`,
    name: 'Modificar',
  },
}
